module.exports = __webpack_public_path__ + "img/canbadge_daishi_60_70mm_trimmark.757ffb82.png";